var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cpt-player-webrtc"},[_c('video',{ref:"webrtc",attrs:{"id":"rtc_media_player","controls":"","autoplay":"","muted":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }